module.exports = __webpack_public_path__ + "static/media/swift.24e1c038.svg";